<script>
import { preventDefault } from "svelte/legacy";
import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import * as m from '@app/paraglide/messages.js';

import correctReadingSpeed from "@cclib/functions/eventGroups/correctReadingSpeed.js";
import { metricsState } from "@app/store/metricsStore.svelte.js";

let maxCps = $state(
        eventGroupState[projectState.selected]
            ? eventGroupState[projectState.selected].maxCps
            : 20,
    ),
    minDuration = $state(
        eventGroupState[projectState.selected]
            ? eventGroupState[projectState.selected].minDuration
            : 0.00001,
    ),
    maxDuration = $state(
        eventGroupState[projectState.selected]
            ? eventGroupState[projectState.selected].maxDuration
            : 12,
    ),
    minFrameGap = $state(2);

let allowMerge = $state(true);

function autoCorrectTiming() {
    try {
        const group = eventGroupState[projectState.selected];
        const { stats } = correctReadingSpeed(group, {
            frameRate: projectState.frameRate,
            maxCps,
            minDuration,
            maxDuration,
            minFrameGap,
            allowMerge,
            maxChars: group.maxChars,
            maxLines: group.maxLines,
            excludeSpaces: metricsState.cpsIncludeSpaces === false,
            markFailures: true,
            failureNote: m.auto_correct_note(),
        });

        // Merges splice the events array, so selection indices are stale
        group.selected = [];

        insertHistoryAction({
            name: "auto correct", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });

        toast.push(
            m.auto_correct_summary({
                corrected: stats.extended,
                merged: stats.merged,
                failed: stats.failed,
            }),
            {
                classes: [stats.failed > 0 ? "toast-warning" : "toast-success"],
            },
        );
    } catch (err) {
        console.log(err, err.message);
        toast.push(m.auto_correct_failed(), {
            classes: ["toast-danger"],
        });
    } finally {
        hideModal();
    }
}
</script>

<div
    class="modal fade {modalState.selected === 'autoCorrectTiming'
        ? 'show d-block'
        : ''}"
    role="dialog"
    tabindex="-1"
    id="AutoCorrectTimingModal"
    aria-labelledby="correctTimingTitle"
    aria-describedby="correctTimingDescription">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="correctTimingTitle">
                    {m.auto_correct_reading_speed()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.close_auto_correct_timing_modal()}
                    onclick={hideModal}>
                </button>
            </div>
            <div class="modal-body">
                <form
                    onsubmit={preventDefault(autoCorrectTiming)}
                    aria-label={m.reading_speed_settings()}>
                    <div class="row mb-3">
                        <div class="col">
                            <label class="form-label" for="maxCpsInput"
                                >{m.max_cps_characters_sec()}</label>
                            <input
                                class="form-control"
                                type="number"
                                min="1"
                                max="100"
                                step="1"
                                id="maxCpsInput"
                                bind:value={maxCps}
                                aria-describedby="maxCpsHelp" />
                        </div>
                    </div>
                    <!-- Duration -->
                    <div class="row mb-3">
                        <div class="col">
                            <label class="form-label" for="minDurationInput"
                                >{m.min_duration_seconds()}</label>
                            <input
                                class="form-control"
                                type="number"
                                min="0"
                                max="100"
                                id="minDurationInput"
                                bind:value={minDuration} />
                        </div>
                        <div class="col">
                            <label class="form-label" for="maxDurationInput"
                                >{m.max_duration_seconds()}</label>
                            <input
                                class="form-control"
                                type="number"
                                min="1"
                                max="100"
                                id="maxDurationInput"
                                bind:value={maxDuration} />
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="minFrameGapInput"
                            >{m.minimum_frame_gap()}</label>
                        <input
                            class="form-control"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            id="minFrameGapInput"
                            bind:value={minFrameGap} />
                    </div>
                    <!-- Allow Merge Checkbox -->
                    <div class="form-check mb-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="allowMergeCheck"
                            bind:checked={allowMerge} />
                        <label class="form-check-label" for="allowMergeCheck">
                            {m.allow_merge_brief_events()}
                        </label>
                    </div>
                    <div class="float-end">
                        <button
                            class="btn btn-primary"
                            id="autoCorrectBtn"
                            onclick={autoCorrectTiming}
                            type="button"
                            aria-label={m.apply_auto_corrections()}
                            >{m.auto_correct()}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
